import { Box, Stack } from '@mui/material';
import EventTag from './EventTag';
import LightTooltip from 'views/Components/Shared/Components/LightTooltip';

function EventsCard({ events }) {
	return (
		<Stack>
			{events.map((event) => (
				<EventTag key={event.name} event={event} />
			))}
		</Stack>
	);
}

export default function MonthEvents({ events }) {
	if (events.length > 1) {
		return (
			<LightTooltip
				title={<EventsCard events={events.slice(1)} />}
				placement="top"
			>
				<Box>
					<EventTag event={events[0]} />
				</Box>
			</LightTooltip>
		);
	}

	return <EventTag event={events[0]} />;
}
